/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { personFragment } from '../../../apollo/fragments/personFragment.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAuthorizedSignerPhoneNumber_updateCreditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson_address_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly city: string | null, readonly state: string | null, readonly street: string | null, readonly streetAdditional: string | null, readonly postalCode: string | null, readonly countryCode: string | null };

export type UpdateAuthorizedSignerPhoneNumber_updateCreditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly title: string | null, readonly dob: any | null, readonly email: string | null, readonly passportCountry: string | null, readonly passportNumberLastFour: string | null, readonly passportExpiration: any | null, readonly passportNumberLength: number | null, readonly phoneNumber: string | null, readonly ssnLastFour: string | null, readonly verifiedPhoneNumber: string | null, readonly address: UpdateAuthorizedSignerPhoneNumber_updateCreditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson_address_CreditApplicationAddress | null };

export type UpdateAuthorizedSignerPhoneNumber_updateCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly authorizedSigner: UpdateAuthorizedSignerPhoneNumber_updateCreditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null };

export type UpdateAuthorizedSignerPhoneNumber_Mutation = { readonly __typename: 'Mutation', readonly updateCreditApplication: UpdateAuthorizedSignerPhoneNumber_updateCreditApplication_CreditApplication };


export type UpdateAuthorizedSignerPhoneNumberVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  authorizedSigner: _Types.PersonInput;
}>;


export type UpdateAuthorizedSignerPhoneNumber = UpdateAuthorizedSignerPhoneNumber_Mutation;


export const UpdateAuthorizedSignerPhoneNumberDocument = gql`
    mutation UpdateAuthorizedSignerPhoneNumber($creditApplicationId: ID!, $authorizedSigner: PersonInput!) {
  updateCreditApplication(
    creditApplicationId: $creditApplicationId
    authorizedSigner: $authorizedSigner
  ) {
    salesforceCreditId
    fetchedAt
    authorizedSigner {
      ...personFragment
    }
  }
}
    ${personFragment}`;
export type UpdateAuthorizedSignerPhoneNumberMutationFn = Apollo.MutationFunction<UpdateAuthorizedSignerPhoneNumber, UpdateAuthorizedSignerPhoneNumberVariables>;

/**
 * __useUpdateAuthorizedSignerPhoneNumber__
 *
 * To run a mutation, you first call `useUpdateAuthorizedSignerPhoneNumber` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizedSignerPhoneNumber` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizedSignerPhoneNumber, { data, loading, error }] = useUpdateAuthorizedSignerPhoneNumber({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      authorizedSigner: // value for 'authorizedSigner'
 *   },
 * });
 */
export function useUpdateAuthorizedSignerPhoneNumber(baseOptions?: Apollo.MutationHookOptions<UpdateAuthorizedSignerPhoneNumber, UpdateAuthorizedSignerPhoneNumberVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthorizedSignerPhoneNumber, UpdateAuthorizedSignerPhoneNumberVariables>(UpdateAuthorizedSignerPhoneNumberDocument, options);
      }
export type UpdateAuthorizedSignerPhoneNumberHookResult = ReturnType<typeof useUpdateAuthorizedSignerPhoneNumber>;
export type UpdateAuthorizedSignerPhoneNumberMutationResult = Apollo.MutationResult<UpdateAuthorizedSignerPhoneNumber>;
export type UpdateAuthorizedSignerPhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdateAuthorizedSignerPhoneNumber, UpdateAuthorizedSignerPhoneNumberVariables>;